<div [ngStyle]="{'max-width': maxWidth}" style="width: 100%">
  <label for="input_1" [ngClass] = "getLabelColorClass()" *ngIf="label">{{title}}<span *ngIf="labelIcon" [ngClass]="labelIcon" class="pl-1 cursor-pointer" (click)="toggleLabelIcon()"></span></label>
  <div *ngIf="!validationSupport"[ngSwitch]="type">

    <input *ngSwitchCase="TEXT_FIELD_TYPES.TEXT" [ngClass]="(disableValidator) ? 'disabled-validator-input' : (disabled || (valid == TEXT_FIELD_VALIDATIONS.DISABLED)) ? 'disabled-input' : valid == TEXT_FIELD_VALIDATIONS.VALID ? 'valid-input' : 'error-input'" [id]="id" class="bx--col"
           [class.input-group] = "isInputGroup"
           [type]="type" [ngModel]="text" [placeholder]="placeholder"
           (input)="textChange.emit($event.target.value)" [pattern]="pattern"
           [required]="required" [disabled]="disabled || disableInput" [readonly]="readonly">

    <input *ngSwitchCase="TEXT_FIELD_TYPES.URL" [ngClass]="(disabled || (valid == TEXT_FIELD_VALIDATIONS.DISABLED)) ? 'disabled-input' : valid == TEXT_FIELD_VALIDATIONS.VALID ? 'valid-input' : 'error-input'" [id]="id" class="bx--col"
           [class.input-group] = "isInputGroup"
           [type]="type" [ngModel]="text" [placeholder]="placeholder"
           (input)="textChange.emit($event.target.value)" [pattern]="pattern"
           [required]="required" [disabled]="disabled || disableInput">

    <input *ngSwitchCase="TEXT_FIELD_TYPES.EMAIL" [ngClass]="(disabled || (valid == TEXT_FIELD_VALIDATIONS.DISABLED)) ? 'disabled-input' : valid == TEXT_FIELD_VALIDATIONS.VALID ? 'valid-input' : 'error-input'" [pattern]="emailRegex" [id]="id" class="bx--col"
           [class.input-group] = "isInputGroup"
           [type]="type" [ngModel]="text" [placeholder]="placeholder"
           (input)="textChange.emit($event.target.value)"
           [required]="required" [disabled]="disabled || disableInput">

    <input *ngSwitchCase="TEXT_FIELD_TYPES.NUMBER" [ngClass]="(disabled || (valid == TEXT_FIELD_VALIDATIONS.DISABLED)) ? 'disabled-input' : valid == TEXT_FIELD_VALIDATIONS.VALID ? 'valid-input' : 'error-input'" [id]="id" class="bx--col"
           [class.input-group] = "isInputGroup"
           [type]="type" [ngModel]="text" [placeholder]="placeholder"
           (input)="textChange.emit($event.target.value)"
           [required]="required" [disabled]="disabled || disableInput">

    <input *ngSwitchCase="TEXT_FIELD_TYPES.PASSWORD" [ngClass]="(disabled || (valid == TEXT_FIELD_VALIDATIONS.DISABLED)) ? 'disabled-input' : valid == TEXT_FIELD_VALIDATIONS.VALID ? 'valid-input' : 'error-input'" [id]="id" class="bx--col"
           [class.input-group] = "isInputGroup"
           [type]="showPassword ? 'text' : 'password'" [ngModel]="text" [placeholder]="placeholder"
           (input)="textChange.emit($event.target.value)"
           [required]="required" [disabled]="disabled || disableInput">

    <textarea *ngSwitchCase="TEXT_FIELD_TYPES.TEXTAREA" [ngClass]="(disabled || (valid == TEXT_FIELD_VALIDATIONS.DISABLED)) ? 'disabled-input' : valid == TEXT_FIELD_VALIDATIONS.VALID ? 'valid-input' : 'error-input'" [id]="id" class="bx--col" [ngModel]="text" [placeholder]="placeholder"
              (input)="textChange.emit($event.target.value)"
              [required]="required" [disabled]="disabled || disableInput"></textarea>

    <span style="position: center; margin-top: 12px; margin-right: 6px" *ngIf="type === TEXT_FIELD_TYPES.PASSWORD" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" class="fas fa-fw input-icon toggle-password"
          (click)="togglePasswordView()"></span>

    <span style="position: center; margin-top: 12px; margin-right: 6px" *ngIf="type !== TEXT_FIELD_TYPES.PASSWORD && icon" [ngClass]="icon" class="fas fa-fw input-icon toggle-password"></span>
  </div>

  <div *ngIf="validationSupport"
        class="d-flex text-field-container"
       [ngClass]="{
       'focus': isInputFocused,
       'error': validationState === VALIDATION_STATE.Invalid
       }"
  >
    <input #textInput class="w-100"
           [ngModel]="text"
           (input)="textChange.emit($event.target.value)"
           [placeholder]="placeholder"
           (focus)="isInputFocused = true"
           (blur)="isInputFocused = false"
           [disabled]="disabled"
           [ngClass]="{'disabled': disabled}"
    >

    <span *ngIf="showEditIcon" class="d-flex justify-content-center align-items-center icon-container validation-status-container"
          [ngStyle]="{'border-left': showValidationBox ? '' : 'none'}"
          (click)="handleEditIconClick()"
          [ngClass]="{
          'focus': isInputFocused,
          'error': validationState === VALIDATION_STATE.Invalid,
          'disabled': disableValidator
           }"
    >
      <span
        *ngIf="validationState === VALIDATION_STATE.None && showEditPencil"
        class="fas fa-pencil"
        style="color: #2595ff; font-size: 18px;"
      >
      </span>

      <span *ngIf="validationState === VALIDATION_STATE.Validating">
        <spinner class="custom-spinner-border" [size]="15" [tickness]="2"></spinner>
      </span>

      <span
        *ngIf="validationState === VALIDATION_STATE.Valid"
        class="fas fa-check"
        style="color: #26B969; font-size: 18px;"
      >
      </span>

      <!-- Show error icon if the state is invalid and showErrorIcon is true; this visually displays a red cross on the UI based on the requirement -->
      <span
        *ngIf="validationState === VALIDATION_STATE.Invalid && showErrorIcon"
        class="fas fa-times"
        style="color: #FF445E; font-size: 18px;"
      >
      </span>
  </span>



  </div>

  <div *ngIf="errorMessage?.length" style="">
    <p *ngIf="(valid === TEXT_FIELD_VALIDATIONS.ERROR && !isInputGroup) || (validationState === VALIDATION_STATE.Invalid)" style="margin-top: 8px" class="error-text">{{errorMessage}}</p>
  </div>

  <div *ngIf="changeButtonVisible" style="margin-top: 8px">
    <span style="float: right;">
      <beaconstac-button (onClick)="onClick.emit($event)" [type]="BUTTON_TYPES.PRIMARY" [label]="changeButtonText" [style]="BUTTON_STYLES.TEXT"></beaconstac-button>
    </span>
  </div>
</div>


<!-----------------------------------Yet to be implemented----------------------------------------------------------->

<!--<div *ngIf="style === TEXT_FIELD_STYLES.PHONE_NUMBER" class="bx&#45;&#45;grid">-->
<!--  <div class="input-group mb-3 bx&#45;&#45;row">-->
<!--    <div class="input-group-prepend">-->
<!--      <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> +91 </button>-->
<!--      <div class="dropdowxn-menu">-->
<!--        <a class="dropdown-item" href="#">Action</a>-->
<!--        <a class="dropdown-item" href="#">Another action</a>-->
<!--        <a class="dropdown-item" href="#">Something else here</a>-->
<!--        <div role="separator" class="dropdown-divider"></div>-->
<!--        <a class="dropdown-item" href="#">Separated link</a>-->
<!--      </div>-->
<!--    </div>-->
<!--    <input type="text" class="form-control" aria-label="Text input with dropdown button">-->
<!--  </div>-->
<!--</div>-->
